// Copyright © 2021 Move Closer
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export var DashmixBoxModeMap;
(function (DashmixBoxModeMap) {
    DashmixBoxModeMap["Clean"] = "clean";
    DashmixBoxModeMap["Divided"] = "divided";
})(DashmixBoxModeMap || (DashmixBoxModeMap = {}));
